<template>
  <div class="common">
    <a-tabs type="card" v-model="tabCur">
      <a-tab-pane v-for="item in tabData" :key="item.key" :tab="item.name">
        <keep-alive v-if="tabCur == item.key">
          <component :is="item.comp" :tabType="item.key" :status="item.status"></component>
        </keep-alive>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>

<script>
import { mapGetters } from "vuex"
import payfeeMain from "@/pages/account/payfee/payfee-main"
export default {
  components: {
    payfeeMain
  },
  name: "payfee",
  data() {
    return {
      tabData: [
        {
          name: "待付费",
          key: "payfeeNo",
          comp: payfeeMain,
          status: "0",
        },
        {
          name: "已付费",
          key: "payfeeHas",
          comp: payfeeMain,
          status: "1,2"
        }
      ],
      tabCur: "payfeeNo"
    }
  },
  computed: {
  },
  created() {
  },
  mounted() {

  },
  methods: {


  },
  activated() {

  },
};
</script>
<style scoped lang="less">
.common {
  /deep/ .ant-tabs-tab-active {
    border-bottom: 1px solid #e8e8e8 !important;
  }

  /deep/ .ant-tabs-bar {
    border-bottom: none !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/account/payfee/payfee.vue